// extracted by mini-css-extract-plugin
export var colFive = "styles-module--colFive--5d4b1";
export var colFour = "styles-module--colFour--5692f";
export var colOne = "styles-module--colOne--56ebe";
export var colThree = "styles-module--colThree--6e704";
export var colTwo = "styles-module--colTwo--0f6de";
export var fiveColTable = "styles-module--fiveColTable--02d33";
export var fiveColTableContainer = "styles-module--fiveColTableContainer--89548";
export var fiveColTableDiv = "styles-module--fiveColTableDiv--019df";
export var title = "styles-module--title--d9546";